import { useSelector } from 'react-redux'

import { Region } from '@babylon/consumer-api/types'
import { ReduxState } from '@/config/redux/types'

const selectRegionInfo = (state: ReduxState): Region => state.regionInfo

const useRegionInfo = () => useSelector(selectRegionInfo)

export { useRegionInfo, selectRegionInfo }
